import { render, staticRenderFns } from "./dropdown-menu.vue?vue&type=template&id=0dcbd446"
import script from "./dropdown-menu.vue?vue&type=script&lang=js"
export * from "./dropdown-menu.vue?vue&type=script&lang=js"
import style0 from "./dropdown-menu.vue?vue&type=style&index=0&id=0dcbd446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports